/**
 * Formate un nombre en euros selon la locale française
 * @param value Montant à formater
 * @param numberDigits Nombre de décimales (défaut : 2)
 */
const formatEuro = (value: number, numberDigits: number = 2): string => {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: numberDigits,
        maximumFractionDigits: numberDigits,
    }).format(value);
};

export default formatEuro;
